import classNames from 'classnames'
import styles from './Button.module.scss'

const Button = ({
  buttonDetails,
  text,
  children,
  classname,
  handleClick,
  disabled = false,
  ...props
}) => {
  return (
    <button
      className={classNames(styles.button, classname)}
      onClick={() => handleClick(buttonDetails)}
      disabled={disabled}
      {...props}
    >
      {text}
      {children}
    </button>
  )
}

export default Button
